module.exports = __webpack_public_path__ + "static/img/testFail.5cf2a3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testFail.png
// module id = pmrz
// module chunks = 2